import { render, staticRenderFns } from "./LuckyGrid.vue?vue&type=template&id=04472cc6&scoped=true&"
import script from "./LuckyGrid.vue?vue&type=script&lang=js&"
export * from "./LuckyGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04472cc6",
  null
  
)

export default component.exports